import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  useTheme,
} from "@mui/material";
import { WhatsApp } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { TextField } from "@mui/material";
import { BookingData } from "../../types/view-booking";
import { tokens } from "../../../../theme";

interface Props {
  open: boolean;
  onClose: () => void;
  bookingData?: BookingData | null;
}

export default function AnniversaryMessageModal({
  open,
  onClose,
  bookingData,
}: Props) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const clientName = bookingData?.organiser?.name || "Family";
  const phone = bookingData?.organiser?.phone || "";
  const deceasedName = bookingData?.beloved?.name || "your loved one";

  const [message, setMessage] = useState("");

  useEffect(() => {
    if (open) {
      setMessage(
        `Dear ${clientName},\n\nAs we mark the anniversary of ${deceasedName}'s passing, we want you to know that our thoughts are with you and your family during this time.\n\nMemories of those we love never fade, and we hope today brings you comfort in remembering the beautiful life they lived.\n\nYou are not alone — we are here if there is anything you need.`
      );
    }
  }, [open, clientName, deceasedName]);

  const handleShareWhatsApp = () => {
    const encoded = encodeURIComponent(message);
    const phoneClean = phone.replace(/\D/g, "");
    window.open(`https://wa.me/${phoneClean}?text=${encoded}`, "_blank");
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { borderRadius: 4, maxWidth: 500, p: 1 } }}
    >
      <DialogTitle
        sx={{
          fontWeight: 600,
          fontSize: 18,
          pb: 1,
        }}
      >
        Anniversary message
      </DialogTitle>

      <DialogContent sx={{ pt: 1, pb: 2 }}>
        <Typography sx={{ fontSize: 12, color: "text.secondary", mb: 2 }}>
          Sending to {clientName} • {phone || "No phone on record"}
        </Typography>

        <TextField
          fullWidth
          multiline
          minRows={8}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          sx={{
            mb: 3,
            "& .MuiOutlinedInput-root": {
              borderRadius: 3,
              bgcolor: colors.primary[800],
              fontSize: 13,
              lineHeight: 1.6,
              "& fieldset": { border: "none" },
            },
          }}
        />

        <Button
          variant="contained"
          fullWidth
          onClick={handleShareWhatsApp}
          startIcon={<WhatsApp />}
          sx={{
            bgcolor: "#25D366",
            color: "white",
            textTransform: "none",
            borderRadius: 2,
            py: 1.2,
            fontSize: 14,
            fontWeight: 500,
            boxShadow: "none",
            "&:hover": {
              bgcolor: "#20bd5a",
              boxShadow: "none",
            },
          }}
        >
          Share via WhatsApp
        </Button>
      </DialogContent>
    </Dialog>
  );
}